<template>
  <CRow>
    <CCol :key="index" class="mb-3 p-1" col="4" v-for="(item,index) in results.exam">
      <CCard class="h-100">
        <CCardHeader>
          <CRow>
            <CCol col="4">
              <strong>Item: {{ index + 1 }}</strong>
            </CCol>
            <CCol class="text-right">
              <span>p-value: {{ item.difficultyIndex.toFixed(2) }}</span><br>
              <span>r-value: {{ item.discriminationIndex.toFixed(2) }}</span>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody class="pl-4 pr-4 pb-0">
          <CRow style="border: 1px solid black; border-right: 0">
            <CCol :key="indexC" class="text-center" style="border-right: 1px solid black;"
                  v-for="(choice,indexC) in item.answers">
              <CRow>
                <CCol>{{ indexC + 1 }} <span v-if="choice.isCorrect">*</span></CCol>
              </CRow>
              <CRow>
                <CCol class="pl-0 pr-0" style="border-top: 1px solid black;">
                  <small>A = {{ choice.answered.toFixed(1) }}</small>
                </CCol>
              </CRow>
              <CRow style="border-top: 1px solid black;">
                <CCol class="pl-0 pr-0" style="border-right: 1px solid black;">
                  <small>U</small>
                </CCol>
                <CCol class="pl-0 pr-0">
                  <small>L</small>
                </CCol>
              </CRow>
              <CRow style="border-top: 1px solid black;">
                <CCol class="pl-0 pr-0" style="border-right: 1px solid black;">
                  <small>{{ choice.upperAnswered.toFixed(1) }}</small>
                </CCol>
                <CCol class="pl-0 pr-0">
                  <small>{{ choice.lowerAnswered.toFixed(1) }}</small>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: "itemAnalysisResult",
  props: {
    results: Object
  }
}
</script>
